<app-breadcrumbs></app-breadcrumbs>
<div class="sidebar-style-9">
  <div class="section">
    <div class="container">
      <form [formGroup]="addOrderForm" >
        <div class="row">
          <div class="col-lg-8">
            <div class="sigma_form style-7">
              <div class="form-block">
                <h5>Your Information:</h5>
                <p class="fill-form-text">Please fill in all fields with "
                  <i class="fal fa-asterisk"></i> " to activate the <strong>Pay</strong> button
                </p>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label>Name</label>
                      <i class="fal fa-user"></i>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Name"
                        [attr.disabled]="true"
                        formControlName="clientName"
                      >
                      <div *ngIf="submitted && f.clientName.errors" class="is-invalid">
                        <div *ngIf="f.clientName.errors.required">Name required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label>Email</label>
                      <i class="fal fa-at"></i>
                      <input 
                        type="email" 
                        class="form-control"
                        placeholder="email"
                        [attr.disabled]="true"
                        formControlName="email"
                      >
                      <div *ngIf="submitted && f.email.errors" class="is-invalid">
                        <div *ngIf="f.email.errors.required">Email required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label>Date of birth</label>
                      <i class="fal fa-calendar-alt"></i>
                      <input 
                        type="text"  
                        data-provide="datepicker"
                        class="form-control"
                        placeholder="'Date of birth'"
                        [attr.disabled]="true"
                        formControlName="birthDate"
                      >
                      <div *ngIf="submitted && f.birthDate.errors" class="is-invalid">
                        <div *ngIf="f.birthDate.errors.required">Birth Date required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label>Phone No. 
                        <i class="fal fa-asterisk is-required"></i>
                      </label>
                      <i class="fal fa-phone"></i>
                      <input 
                        type="text" 
                        class="form-control"
                        placeholder="+256742345678"
                        formControlName="telephone"
                      >
                      <div *ngIf="submitted && f.telephone.errors" class="is-invalid">
                        <div *ngIf="f.telephone.errors.required">Telephone required</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-block">
                <h5>
                    {{ !isDrug && cartItems.length < 0? 'Test Order Information:' : 
                      (addConsultation && cartItems.length < 0 && isDrug ? 
                      'Client Medical History:' : 'Client Medical Information') 
                    }}
                  
                </h5>
                <div class="row">
                  <div *ngIf="cartItems.length > 0" class="col-lg-6">
                    <div class="form-group">
                      <label> {{ isDrug ? 'Schedule delivery date' : 'Date when available' }}
                        <i class="fal fa-asterisk is-required"></i> 
                      </label>
                      <input 
                        type="date"  
                        data-provide="datepicker"
                        class="form-control"
                        placeholder="'Date of Availability'"
                        formControlName="availability"
                        [min]="disableDate"
                      >
                      <div *ngIf="submitted && f.availability.errors" class="is-invalid">
                        <div *ngIf="f.availability.errors.required">Date when available required</div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="addConsultation && cartItems.length === 0" class="col-lg-6">
                    <div class="form-group">
                      <label> 
                        Choose a date for consultation 
                        <i class="fal fa-asterisk is-required"></i>
                      </label>
                      <input 
                        type="datetime-local"  
                        data-provide="datepicker"
                        class="form-control"
                        placeholder="'Date of Availability'"
                        formControlName="availability"
                        [min]="disableDate"
                        (change)="convertTo12HourFormat($event)"
                      >
                      <div *ngIf="submitted && f.availability.errors" class="is-invalid">
                        <div *ngIf="f.availability.errors.required">Date for consultation required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label>District 
                        <i class="fal fa-asterisk is-required"></i>
                      </label>
                      <select 
                        class="form-control"
                        placeholder="District"
                        formControlName="district"
                      >
                      <option value="" disabled selected>District</option>
                      <option *ngFor="let location of locations" [value]="location">{{ location }}</option>
                      </select>
                      <div *ngIf="submitted && f.district?.errors?.required" class="is-invalid">
                        District required
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label>Enter Precise Location 
                        <i class="fal fa-asterisk is-required"></i>
                      </label>
                      <i class="fal fa-location-arrow"></i>
                      <textarea  
                        rows="5" 
                        class="form-control"
                        placeholder="Give precise location details"
                        formControlName="location"
                      >
                      </textarea>
                      <div *ngIf="submitted && f.location.errors" class="is-invalid">
                        <div *ngIf="f.location.errors.required">Location required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label>
                        {{ addConsultation ? 
                          'Write a list of your medical complaints' : 
                          'Additional Notes' }}
                        <i class="fal fa-asterisk is-required"></i>
                      </label>
                      <textarea  
                        rows="7" 
                        value="" 
                        class="form-control"
                        placeholder="Note To Us"
                        formControlName="note"
                      >
                      </textarea>
                    </div>
                  </div>
                  <div *ngIf="isDrug" class="col-md-12">
                    <app-checkbox
                      formControlName="termsAndConditions"
                      [formGroup]="addOrderForm"
                    >
                      <span>
                        I confirm that the above information is correct 
                      </span>
                    </app-checkbox>
                    <div
                      class="is-invalid"
                      *ngIf="submitted && !f.termsAndConditions.value"
                    >
                      Required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-block">
                <h4>Payment:</h4>
                <h5>Billing Address:</h5>
                <div class="row mt-3">
                  <div class="col-lg-10">
                    <div>
                      <form 
                        [formGroup]="paymentForm" 
                        (ngSubmit)="submitOrder()"
                      >
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="form-group">
                              <label>Phone number
                                <i class="fal fa-asterisk is-required"></i>
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                placeholder="0772123456"
                                formControlName="phone_number"
                              >
                              <div *ngIf="submitted && paymentForm.controls.phone_number.errors" class="is-invalid">
                                <div *ngIf="paymentForm.controls.phone_number.errors.required">Country Required</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="form-group">
                              <label>Country
                                <i class="fal fa-asterisk is-required"></i>
                              </label>
                              <select 
                                class="form-control"
                                placeholder="Uganda"
                                formControlName="country"
                              >
                              <option value="" disabled selected>Country</option>
                              <option *ngFor="let country of countryCodes" [value]="country.name">{{ country.name }}</option>
                              </select>
                              <div *ngIf="submitted && paymentForm.controls.country?.errors?.required" class="is-invalid">
                                Country required
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="form-group">
                              <label>City <i class="fal fa-asterisk is-required"></i></label>
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Kampala"
                                formControlName="city"
                              >
                              <div *ngIf="submitted && paymentForm.controls.City?.errors?.required" class="is-invalid">
                                City required
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="form-group">
                              <label>Address line 1 / street
                                <i class="fal fa-asterisk is-required"></i>
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Bugolobi Luthuli Rise"
                                formControlName="line_1"
                              >
                              <div *ngIf="submitted && paymentForm.controls.line_1.errors" class="is-invalid">
                                <div *ngIf="paymentForm.controls.line_1.errors.required">City Required</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button 
                          type="submit" 
                          [disabled]="addOrderForm.invalid || totalCartCost === 0"
                          class="sigma_btn btn-block btn-sm mt-4 pay-button"
                        >
                          {{ 'Pay ' + totalCartCost + ' UGX' }}
                          <i class="fal fa-arrow-right ml-3"></i>
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="sidebar style-10 mt-5 mt-lg-0">
              <!-- Booking Widget -->
              <div class="widget widget-booking">
                <h5 class="widget-title">Order Summary</h5>
                <div class="test-names-container">
                  <span class="order-summary-title pb-2 text-center">
                    {{ isDrug ? 'Medications' : (addConsultation ? 'Items Ordered' : 'Test Name(s)') }}
                  </span>
                  <ul class="test-names">
                    <li *ngFor="let item of cartItems; let i = index;" class="single-test-name">
                      {{(i + 1) + '. ' + cartItemName[item.id] }}
                      <span> ({{ productQuantities[i].quantity }}) </span>
                    </li>
                    <li *ngIf="addConsultation">
                      {{ (cartItems.length + 1) + '. ' }} Medical Consultation
                    </li>
                  </ul>
                </div>
                <hr>
                <ul>
                  <li class="d-flex align-items-center justify-content-between">
                    <span class="order-summary-title">Availability</span>
                    <span *ngIf="cartItems.length > 0">{{f.availability.value}}</span>
                    <span *ngIf="addConsultation && cartItems.length === 0">{{setTimeValue}}</span>
                  </li>
                  <li class="d-flex align-items-center justify-content-between">
                    <span class="order-summary-title">Name</span>
                    <span>{{f.clientName.value}}</span>
                  </li>
                  <li class="d-flex align-items-center justify-content-between">
                    <span class="order-summary-title">District</span>
                    <span>{{f.district.value}}</span>
                  </li>
                  <li class="d-flex align-items-center justify-content-between">
                    <span class="order-summary-title">Telephone</span>
                    <span>{{f.telephone.value}}</span>
                  </li>
                </ul>
                <hr>
                <ul>
                  <li 
                    *ngIf="cartItems.length > 0"
                    class="d-flex align-items-center justify-content-between">
                    <span class="order-summary-title">{{ isDrug ? 'Total Drugs' : 'Total Tests' }}</span>
                    <span>{{ cartItems.length }}</span>
                  </li>
                  <li class="d-flex align-items-center justify-content-between">
                    <span class="order-summary-title">Total Cost</span>
                    <span>{{ totalCartCost + ' UGX' }}</span>
                  </li>
                  <li 
                    *ngIf="cartItems.length > 0 && !isDrug"
                    class="d-flex align-items-center justify-content-between">
                    <span class="order-summary-title">Sample Pickup Fee</span>
                    <span>0 UGX</span>
                  </li>
                </ul>
                <hr>
                <ul>
                  <li class="d-flex align-items-center justify-content-between">
                    <span class="order-summary-title secondary-color"><b>Total Cost</b></span>
                    <span class="secondary-color"><b>{{ totalCartCost + ' UGX' }}</b></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
